<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="modelValue && user" class="profile-modal">
        <div class="modal-backdrop" @click="close"></div>
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-header__h2">{{ user.fullname }}</h2>
            <button class="profile-modal__close" @click="close" aria-label="Close">
              <Icon
                name="close"
                size="25"
              />
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body__info">
              <div class="profile-avatar" @click="showAvatarGeneratorModal">
  						  <div v-if="typeof avatar == null" class="profile-avatar-placeholder">+</div>
  						  <div 
  						  	v-else 
  						  	class="profile-avatar-placeholder"
  						  >
  						  	<AvatarPreview class="avatar-preview__container" :avatarData="user.avatar" :visible="true"/>
  						  </div>
  						</div>

  						<AvatarGenerator 
  						  v-model:visible="isAvatarGeneratorVisible"
  						  v-model="user.avatar" 
  						  @select="onAvatarSelect"
  						/>

              <div class="profile-info">
                <p class="profile-info__p"><strong>Почта:</strong><input class="profile-info__input" v-model="user.email"/></p>
                <p class="profile-info__p"><strong>Телефон:</strong><input class="profile-info__input" v-model="user.phone"/></p>
                <p class="profile-info__p"><strong>Населенный пункт:</strong><input class="profile-info__input" v-model="user.city"/></p>
              </div>
            </div>

            <div class="modal-body__link">
              <div class="profile-info__link">
                <div class="profile-info__block">
                  <p><strong>Телеграм:</strong> {{ user.tg || 'Не привязан' }}</p>
                  <CheckboxField v-model="user.tg_access">
                    <p>Присылать сообщения</p>
                  </CheckboxField>
                  <button @click="connectTelegram">{{!user.chat_id ? 'Привязать' : 'Перепривязать'}}</button>
                </div>
                <div class="profile-info__block">
                  <p><strong>Почта:</strong> {{ user.email }}</p>
                  <CheckboxField v-model="user.email_access">
                    <p>Присылать сообщения</p>
                  </CheckboxField>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-bottom">
            <button class="modal-bottom__button cancel__button" @click="logout">
              Выйти
            </button>
            <button class="modal-bottom__button" @click="updateUser()">
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import AvatarGenerator from '@/components/UI/Generator/Avatar.vue';
import AvatarPreview from '@/components/UI/Generator/AvatarPreview.vue';
import CheckboxField from "@/components/UI/Select/Checkbox.vue";

export default {
  name: 'ProfileModal',
  components: { AvatarGenerator, AvatarPreview, CheckboxField },
  props: {
    modelValue: Boolean,
  },
  data() {
    return {
      isAvatarGeneratorVisible: false,
    };
  },
  computed: {
    user () {
      return this.$store.getters['user/user']
    }
  },
  watch: {
    modelValue(val) {
	    if (val) document.body.classList.add('no-scroll');
	    else document.body.classList.remove('no-scroll');
	  }
  },
  beforeUnmount() {
	  document.body.classList.remove('no-scroll');
	},
  methods: {
    updateUser () {
      this.$store.dispatch('user/updateUser', this.user)
    },
    async logout () {
      await this.$store.dispatch('user/logout')
      location.reload()
    },
    connectTelegram() {
      const payload = {
        uid: this.user.uid,  // ⚡ меняем ключ
      };
      const startParam = btoa(JSON.stringify(payload));
      const tgBotLink = `https://t.me/sitebypro_official_bot?start=${startParam}`;
      window.open(tgBotLink, "_blank");
    },
  	showAvatarGeneratorModal () {
  		this.isAvatarGeneratorVisible = !this.isAvatarGeneratorVisible
  	},
    close() {
      this.$emit('update:modelValue', false);
    },
    onAvatarSelect(avatar) {
      //this.localUser.avatar = avatar;
    }
  }
};
</script>

<style scoped>
.profile-modal__close {
  background: transparent;
  padding: 0;
  color: white;
}
.profile-modal__close:hover {
  opacity: 0.5
}
.profile-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-backdrop {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
}

.modal-content {
  position: relative;
  background: var(--grey-1);
  border-radius: 1rem;
  width: 30rem;
  max-width: 90%;
  z-index: 10;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.1rem solid var(--grey-0);
}

.modal-footer {
  
}

.modal-body {
  padding: 1rem;
  border-bottom: 0.1rem solid var(--grey-0);
}
.modal-body__info {
  border-bottom: 0.1rem solid var(--grey-0);
  display: flex;
  gap: 1rem;
  padding-bottom: 1rem;
}

.modal-body__link {
  display: flex;
  gap: 1rem;
  padding-top: 1rem;
}

.profile-avatar {
  width: 6.25rem;
  height: 6.25rem;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
}

.profile-avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}

.profile-avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(135deg,#e9e9e9,#f5f5f5);
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:1.5rem;
  color:#777;
}

.profile-info {
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  display: flex;
}
.profile-info p {
  text-align: left;
}


/* Плавное появление */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: scale(1);
}
.modal-header__h2 {
  font-size: 1.5rem;
}
.avatar-preview__container {
  min-width: 6.25rem;
  width: 6.25rem;
  min-height: 6.25rem;
  height: 6.25rem;
  max-heigth: 6.25rem;

}
.profile-info__link {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 1rem;
}
.profile-info__block {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 0.5rem;
}
.profile-info__block > *:not(:first-child) {
  margin-left: 0.5rem;
}
.modal-bottom {
  padding: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.modal-bottom__button:hover {
  opacity: 0.8
}
.cancel__button {
  background: transparent;
  color: var(--color-0);
  border: 0.1rem solid var(--color-0);
}
.profile-info__input {
  background-color: var(--grey-1);
  color: var(--color-0);
  font-weight: bold;
  font-size: 1rem;
  border: 0.1rem solid var(--grey-0);
  border-radius: 0.5rem;
  padding: 0.5rem;
  width: 100%;
}
.profile-info__input:focus {
  border: 0.1rem solid var(--blue-0);
  outline: none;
}
.profile-info__p {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-wrap: nowrap;
  width: 100%;
}
</style>
